import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RemoveRedEyeOutlined, SearchOutlined } from "@material-ui/icons";
import { FileDownloadSharp } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Grid,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { exportToExcelJS } from "../helpers/ExcelJsHelper";
import { isTokenCreatedToday } from "../helpers/TokenHelpers";
import { useQuery } from "../hooks/useQuery";
import useToast from "../hooks/useToast";
import { historiqueService } from "../service/HistoriqueService";
import { EXTERNAL_POSTULANT_ATTRIBUTES_COLUMNS } from "./ListCandidat";
import Menu from "./Menu";
import logo from "./logo.png";
import StandardSkeletoon from "./reusable/loader/StandardSkeletoon";
import { TYPE_NOTIFICATION } from "./utils/NotificationBull";

const Admin = ({ prec_url }) => {
  const { Toast, showToast } = useToast();
  const [idsButons, setIdsButons] = useState([]);
  const [rows, setRows] = useState([]);
  const [filtre, setFiltre] = useState({ mot: "", status: null });
  const [rowsData, setRowsData] = useState([]);
  const query = useQuery();
  const [loadingData, setLoadingData] = useState(false);
  const [postulantList, setPostulantList] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let token = query.get("ref");
    if (isTokenCreatedToday(token)) {
      localStorage.setItem("CODE_ADMIN", token);
    } else {
      showToast(TYPE_NOTIFICATION.ERROR, "Token non fourni ou invalide");
      navigate("/");
    }
  }, []);

  const handleDownloadExcel = (rows, columns) => {
    if (rows.length > 0) {
      /* exportToExcel(
        rows,
        columns,
        rows.at(0).libelle_type || "Liste des candidats",
        false,
      ); */
      exportToExcelJS(
        rows,
        columns,
        rows.at(0).libelle_type || "Liste des candidats",
        false,
      );
    } else {
      showToast(
        TYPE_NOTIFICATION.ERROR,
        "Erreur de l'exportation de données excel",
      );
    }
  };

  const handleFetchCandidatList = (id_type) => {
    handleLoadThisButton(id_type + "Exp");
    historiqueService
      .getListeCandidat(id_type)
      .then((res) => {
        if (res && res.data) {
          setPostulantList(res.data);
          handleDownloadExcel(res.data, EXTERNAL_POSTULANT_ATTRIBUTES_COLUMNS);
        }
      })
      .finally(() => {
        handleUnloadThisButton(id_type + "Exp");
      });
  };

  const columns = [
    { field: "description", headerName: "AMI", width: 250 },
    { field: "libelle_type", headerName: "Titre", width: 400 },
    // {
    //   field: "date_debut_publication",
    //   headerName: "Date d'envoie",
    //   width: 200,
    //   valueFormatter: (params) =>
    //     dayjs(params.value).format("DD/MM/YYYY à hh : mm"),
    // },
    {
      field: "cloture",
      headerName: "Cloturé",
      with: 150,
      valueFormatter: (params) => (params.value === "1" ? "Oui" : "Non"),
    },
    {
      field: "",
      headerName: "Actions",
      width: 200,
      renderCell: (params) => (
        <Grid display="flex" gap={1} alignContent={"center"} height={"100%"}>
          <Grid item>
            <LoadingButton
              variant="contained"
              size="small"
              sx={{
                minWidth: "36px",
                borderRadius: "8px",
                p: 0.5,
                boxShadow: "0 2px 8px rgba(156, 39, 176, 0.3)",
              }}
              loading={idsButons.includes(params.row.id_type)}
              // disabled={!params.row.file_cv}
              color="secondary"
              title="Afficher liste des postulants"
              onClick={(e) =>
                navigate(
                  `/administrations/liste_candidat_externe?ref=${localStorage.getItem("CODE_ADMIN")}&id_type=${params.row.id_type}`,
                )
              }
            >
              <RemoveRedEyeOutlined fontSize="small" />
            </LoadingButton>
          </Grid>
          <Grid item>
            <LoadingButton
              variant="contained"
              size="small"
              sx={{
                minWidth: "36px",
                borderRadius: "8px",
                p: 0.5,
                boxShadow: "0 2px 8px rgba(46, 125, 50, 0.3)",
              }}
              loading={idsButons.includes(params.row.id_type + "down")}
              color="success"
              title="Telecharger tous les documents envoyés"
              onClick={(e) =>
                handleDownloadAllFiles(
                  params.row.id_type,
                  params.row.libelle_type,
                )
              }
            >
              <FileDownloadSharp fontSize="small" />
            </LoadingButton>
          </Grid>
          <Grid item>
            <LoadingButton
              variant="contained"
              size="small"
              sx={{
                minWidth: "36px",
                borderRadius: "8px",
                p: 0.5,
                boxShadow: "0 2px 8px rgba(25, 118, 210, 0.3)",
              }}
              loading={idsButons.includes(params.row.id_type + "Exp")}
              // disabled={!params.row.file_cv}
              color="primary"
              title="Exporter liste des postulant en excel"
              onClick={(e) => handleFetchCandidatList(params.row.id_type)}
            >
              <FontAwesomeIcon icon={faFileExcel} size="xl" />
            </LoadingButton>
          </Grid>
        </Grid>
      ),
    },
  ];

  const handleFilter = (filtre) => {
    if (!filtre || (!filtre.mot && !filtre.status)) {
      setRowsData(rows);
      return;
    }
    // const statusFIltered = (item) =>
    //   !filtre.status || filtre.status === ""
    //     ? true
    //     : item.cloture === filtre.status;
    const mot = filtre.mot.toLowerCase();
    setRowsData(
      rows.filter((item) =>
        Object.values(item).some(
          (val) => val && val.toString().toLowerCase().includes(mot),
        ),
      ),
    );
  };

  const handleLoadThisButton = (ids) => {
    setIdsButons([...idsButons, ids]);
  };

  const handleUnloadThisButton = (ids) => {
    setIdsButons(idsButons.filter((id) => id !== ids));
  };

  const handleFetchOffresList = () => {
    setLoadingData(true);
    historiqueService
      .getOffreList()
      .then((res) => {
        if (res && res.data) {
          setRows(res.data);
          setRowsData(res.data);
        }
      })
      .finally(() => {
        setLoadingData(false);
      });
  };

  const handleDownloadAllFiles = (
    id_position,
    file_name = "Documents envoyés",
  ) => {
    handleLoadThisButton(id_position + "down");
    historiqueService
      .downloadAllDocByIdPosition(id_position)
      .then((response) => {
        if (response.status !== 200) {
          showToast(TYPE_NOTIFICATION.ERROR, "Echec de telechargement");
          handleLoadThisButton(false);
          return;
        }
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `${file_name || "Document de tous les candidats"} .zip`,
        );
        document.body.appendChild(link);
        link.click();
      })
      .catch((e) => {
        showToast(TYPE_NOTIFICATION.ERROR, e.tosTring());
      })
      .finally(() => {
        handleUnloadThisButton(id_position + "down");
      });
  };

  const handleDownload = (ref, file_name) => {
    handleLoadThisButton(ref);
    historiqueService
      .downloadCV(ref)
      .then((res) => {
        if (res) {
          console.log(res);

          if (res.status !== 200) {
            showToast(TYPE_NOTIFICATION.ERROR, res.message);
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `CV_${file_name || new Date().toLocaleString()}.pdf`,
            );
            document.body.appendChild(link);
            link.click();
          }
        }
      })
      .catch((e) => {
        showToast(TYPE_NOTIFICATION.ERROR, e.tosTring());
      })
      .finally(() => {
        handleUnloadThisButton(ref);
      });
  };

  useEffect(() => {
    if (filtre) {
      handleFilter(filtre);
    }
  }, [filtre]);

  useEffect(() => {
    handleFetchOffresList();
  }, []);

  return (
    <Grid
      container
      sx={{
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Menu />
      <Grid
        item
        xs={12}
        md={11}
        lg={10}
        xl={9}
        sx={{
          minHeight: "90vh",
          backgroundColor: "#ffffff",
          borderRadius: "24px",
          boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.08)",
          display: "flex",
          flexDirection: "column",
          p: { xs: 2, md: 4 },
          mt: 4,
          mb: 4,
          overflow: "hidden",
        }}
      >
        <Grid
          container
          alignItems={"center"}
          justifyContent={"center"}
          mb={4}
          flexDirection={"column"}
        >
          <img
            src={logo}
            className="App-logo"
            alt="logo"
            style={{ maxWidth: "60px", maxHeight: "60px", marginBottom: "8px" }}
          />
          <Typography
            variant="h4"
            fontWeight={700}
            color="primary.main"
            sx={{ letterSpacing: "-0.5px" }}
          >
            Offres d'emplois externes
          </Typography>
        </Grid>

        <Toast />

        <Box
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column", gap: 3 }}
        >
          {/* Filters and Search */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "16px",
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
              display: "flex",
              flexWrap: "wrap",
              gap: 2,
              alignItems: "center",
            }}
          >
            <Box sx={{ flexGrow: 1 }}>
              <TextField
                size="small"
                fullWidth
                variant="outlined"
                onChange={(e) => setFiltre({ ...filtre, mot: e.target.value })}
                placeholder="Rechercher une offre, AMI, titre..."
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchOutlined color="action" />
                      </InputAdornment>
                    ),
                    sx: { borderRadius: "12px", backgroundColor: "white" },
                  },
                }}
              />
            </Box>
          </Paper>

          {/* DataGrid */}
          <Box
            sx={{
              flexGrow: 1,
              minHeight: "400px",
              height: "60vh",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "16px",
              overflow: "hidden",
              border: "1px solid #e2e8f0",
            }}
          >
            <StandardSkeletoon col={3} row={8} show={loadingData} />
            <DataGrid
              columns={columns}
              rows={rowsData}
              getRowId={(row) => row.id_type}
              localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              hideFooter
              sx={{
                display: loadingData ? "none" : "flex",
                border: "none",
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#f8fafc",
                  color: "#334155",
                  fontWeight: 700,
                  fontSize: "14px",
                  borderBottom: "2px solid #e2e8f0",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #f1f5f9",
                  fontSize: "14px",
                },
                "& .MuiDataGrid-row:hover": {
                  backgroundColor: "#f8fafc",
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1px solid #e2e8f0",
                },
              }}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Admin;
